import React, { useContext } from 'react';
import { Button } from 'reactstrap';
import { GlobalAppContext } from '@context';
import BurgerIcon from './BurgerIcon';

const BurgerButton = () => {
  const { dispatch, state } = useContext(GlobalAppContext);
  const { isMobileNavOpen } = state;

  return (
    <Button
      className="burger-button d-flex flex-nowrap justify-content-center align-items-center d-md-none border-0 p-0 mr-3"
      color="transparent"
      onClick={() => dispatch({
        type: 'SET_MOBILE_NAV_STATE',
        payload: !isMobileNavOpen,
      })}
    >
      <BurgerIcon />
    </Button>
  );
};

export default BurgerButton;
